import * as React from 'react';
import classnames from 'classnames';
import { shallowEqual, useSelector } from 'react-redux';

import { isAuthorizedUser } from '~/config/user';
import { IActiveDogTag } from '~/interfaces';
import { State } from '~/Reducers';

import styles from './ActiveDoll.scss';

interface IState {
    activeDogTag: IActiveDogTag;
}

const stateSelector = (state: State): IState => {
    return {
        activeDogTag: state.ReducerApp.inventory?.activeDogTag,
    };
};

const ActiveDoll = () => {
    const { activeDogTag } = useSelector<State, IState>(stateSelector, shallowEqual);

    if (!isAuthorizedUser() || !activeDogTag?.symbol?.icons?.medium) {
        return null;
    }

    const isColorizable = activeDogTag.isColorizable || !!activeDogTag.texture?.backgroundIcons?.medium;
    const symbolImage = activeDogTag.symbol.icons.medium;
    const backgroundImage = isColorizable ? activeDogTag.texture.backgroundIcons.medium : activeDogTag.background?.icons?.medium;
    const borderImage = isColorizable ? activeDogTag.texture.borderIcons?.medium : '';
    const borderColor = (isColorizable && activeDogTag.borderColor?.replace('0x', '#')) || 'none';
    const backgroundColor = (isColorizable && activeDogTag.backgroundColor?.replace('0x', '#')) || 'none';

    return (
        <div className={styles.activeDogTag}>
            {backgroundImage && (
                <div
                    className={classnames(styles.background, styles.component, isColorizable && styles.colorizable)}
                    style={
                        {
                            '--image': `url('${backgroundImage}')`,
                            backgroundColor: backgroundColor,
                        } as React.CSSProperties
                    }
                >
                    <img src={backgroundImage} />
                </div>
            )}
            {borderImage && (
                <div
                    className={classnames(styles.border, styles.component, isColorizable && styles.colorizable)}
                    style={
                        {
                            '--image': `url('${borderImage}')`,
                            backgroundColor: borderColor,
                        } as React.CSSProperties
                    }
                >
                    <img src={borderImage} />
                </div>
            )}
            {symbolImage && (
                <div className={classnames(styles.symbol, styles.component)}>
                    <img src={symbolImage} />
                </div>
            )}
        </div>
    );
};

export default ActiveDoll;
